import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, HelpBlock, ControlLabel } from 'react-bootstrap';
import PhoneInput from 'react-phone-number-input';
import FontAwesome from 'react-fontawesome';
import 'react-phone-number-input/style.css';
import { withNamespaces } from 'react-i18next';

const CustomArrow = () => <FontAwesome name='angle-down' style={{ marginLeft: 5 }} />;

const PhoneNumber = ({ horizontal, placeholder, labelCol = 3, valueCol = 9, required, label, staticLabel, help, meta: { touched, error, warning }, input: { onChange, value, defaultCountry }, t, ...props }) => {
    const validationState = touched && (error && "error") || (warning && "warning") || null;

    const formControl = <PhoneInput onChange={onChange} value={value} label={label} defaultCountry={defaultCountry}
        countrySelectProps={{ arrowComponent: CustomArrow }}
        {...props} />;

    help = help || t('PhoneNumber_HelpText');
    const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
    const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
    const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

    if (horizontal) {
        return (
            <FormGroup validationState={validationState} className='row'>
                <Col componentClass={ControlLabel} sm={labelCol}>
                    {label}{labelHint}
                </Col>
                <Col sm={valueCol}>
                    {formControl}
                    {errorBlock}
                    {helpBlock}
                </Col>
            </FormGroup>);
    }

    return (
        <FormGroup validationState={validationState}>
            <ControlLabel>{label}{labelHint}</ControlLabel>
            {formControl}
            {errorBlock}
            {helpBlock}
        </FormGroup>
    );
};

PhoneNumber.propTypes = {
    horizontal: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.string,
    help: PropTypes.string,
    meta: PropTypes.object,
    placeholder: PropTypes.string,
    disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    componentClass: PropTypes.string,
    value: PropTypes.string
};

export default withNamespaces()(PhoneNumber);